import { ValueFormatterParams } from '@access-erp/ui-components';
import dayjs from 'dayjs';

import { DATE_TIME_PATTERN, DEFAULT_DATE_PATTERN } from '@/config/common.config';
import { NumberUtils } from '@/utils/numbers.utils';


export class CellFormatters {
  static date(params: ValueFormatterParams) {
    return params?.value ? dayjs(params.value).format(DEFAULT_DATE_PATTERN) : '';
  }

  static dateAndTime(params: ValueFormatterParams) {
    return params?.value ? dayjs(params.value).format(DATE_TIME_PATTERN) : '';
  }

  static decimal(params: ValueFormatterParams) {
    return NumberUtils.prettifyWithRound(params.value);
  }

  static integer(params: ValueFormatterParams) {
    return NumberUtils.prettifyWithRound(params.value, 3, ',', 0);
  }

  static currency(params: ValueFormatterParams, currency: string) {
    return `${currency ?? ''} ${CellFormatters.decimal(params)}`;
  }

  static stockCodeAndName(stockCode?: string, stockName?: string) {
    if (stockCode && stockName) {
      return `${stockCode} - ${stockName}`;
    }

    return stockCode ?? stockName ?? '';
  }
}
